import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/components/theme-provider";
import Providers from "@/lib/providers";
import { NavigationStatus } from "@/components/shell/page-loading";

/**
 * The application root. Formerly `app/layout.tsx`; the `<html>` and `<body>`
 * elements it rendered now live in index.html, since a static SPA ships one
 * document rather than rendering it per request.
 */
export function Root() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="default-light"
      enableSystem
      themes={["default-light", "default-dark"]}
      disableTransitionOnChange
    >
      <Providers>
        <Outlet />
      </Providers>
      <NavigationStatus />
      <Toaster richColors closeButton position="bottom-right" />
    </ThemeProvider>
  );
}

export default Root;
